/* global jQuery */

// THEME FILES
// -----------------------------------------------------------------------------
import anchorBox from '../../source/js/anchor-box.js';
// this instantiates the scrolling for the secondary anchor box
new anchorBox();

// VENDOR FILES
// -----------------------------------------------------------------------------

// CUSTOM CODE
// -----------------------------------------------------------------------------

// Remove the PHPSESSID cookie if it exists
if (document.cookie.indexOf('PHPSESSID') >= 0) {
    document.cookie = 'PHPSESSID=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
}

const fetchLatestUserData = () => {
    if (typeof window.ensureUserDataUpToDate === 'function') {
        return window.ensureUserDataUpToDate();
    }

    if (typeof window.refreshTpashUser === 'function') {
        return window.refreshTpashUser();
    }

    if (typeof window.getUserDataSnapshot === 'function') {
        return Promise.resolve(window.getUserDataSnapshot());
    }

    return Promise.resolve({});
};

const searchForms = document.querySelectorAll('.js-global-search-form');
if (searchForms.length > 0) {
    searchForms.forEach((form) => {
        let searchInput = form.querySelector('input[name="s"]');
        let clearButton = form.querySelector('.js-clear-button');

        searchInput.addEventListener('input', () => {
            if (searchInput.value.length > 2) {
                clearButton.style.display = 'inline-block';
            } else {
                clearButton.style.display = 'none';
            }
        });

        // Update the event listener for the enter key
        searchInput.addEventListener('keypress', (event) => {
            if (event.key === 'Enter') {
                form.submit(); // Submit the form
            }
        });

        clearButton.addEventListener('click', (event) => {
            event.preventDefault();
            searchInput.value = '';
            searchInput.focus();
            clearButton.style.display = 'none';
        });
    });
}

jQuery(document).ready(function () {
    // Delegate Bootstrap's popovers from a stable ancestor. Load More and topic
    // filters insert cards after ready, so binding only the initial cards leaves
    // every later card without a menu. Bootstrap creates each instance on demand.
    jQuery(document.body).popover({
        selector: '.kebob-popover',
        html: true,
        placement: 'bottom',
        trigger: 'click',
        content: '<span class="cpy-link js-copy-link">Copy Link</span>',
    });

    // Delegate the action too, so it works as soon as the menu appears, including
    // during Bootstrap's opening animation. Resolve its owning trigger from the
    // generated popover ID instead of sharing one URL between all open menus.
    jQuery(document).on('click', '.popover .js-copy-link', async function () {
        const popover = this.closest('.popover');
        const trigger = jQuery(`.kebob-popover[aria-describedby="${popover.id}"]`);
        const copyData = trigger.find('[data-copy-data]').addBack('[data-copy-data]').first().attr('data-copy-data');
        if (!copyData) {
            return;
        }

        try {
            await navigator.clipboard.writeText(new URL(copyData, window.location.origin).href);
            jQuery(this).text('Copied!');
            setTimeout(() => {
                trigger.popover('hide');
            }, 750);
        } catch {
            jQuery(this).text('Unable to copy. Try again.');
        }
    });

    jQuery('[rel]').click(function () {
        jQuery('[rel]').not(this).removeClass('header-nav-trigger-expanded');
        jQuery(this).toggleClass('header-nav-trigger-expanded');
        var rel = jQuery(this).attr('rel');
        jQuery('.header-nav-dropdown')
            .not('#' + rel)
            .removeClass('header-nav-dropdown-expanded');
        var $dropdown = jQuery('#' + rel).toggleClass('header-nav-dropdown-expanded');
        jQuery('.header-nav-secondary').removeClass('header-nav-secondary-expanded');
        // Only show overlay if dropdown is expanded
        if ($dropdown.hasClass('header-nav-dropdown-expanded')) {
            jQuery('.nav-overlay').fadeIn(300);
        } else {
            jQuery('.nav-overlay').fadeOut(150);
        }
    });

    // Close nav overlay and dropdowns when clicking outside
    jQuery(document).on('mousedown', function (e) {
        var $navOverlay = jQuery('.nav-overlay');
        var $dropdown = jQuery('.header-nav-dropdown.header-nav-dropdown-expanded');
        var $trigger = jQuery('[rel].header-nav-trigger-expanded');
        // If overlay is visible and click is outside dropdown and trigger
        if (
            $navOverlay.is(':visible') &&
            !$dropdown.is(e.target) &&
            $dropdown.has(e.target).length === 0 &&
            !$trigger.is(e.target) &&
            $trigger.has(e.target).length === 0
        ) {
            $navOverlay.fadeOut(150);
            $dropdown.removeClass('header-nav-dropdown-expanded');
            $trigger.removeClass('header-nav-trigger-expanded');
        }
    });

    jQuery(window).scroll(function () {
        // Only close secondary nav and toolbox, not main nav overlay
        jQuery('.header-nav-secondary').removeClass('header-nav-secondary-expanded');
        jQuery('[rel]').removeClass('header-nav-trigger-expanded');
        jQuery('.header-nav-dropdown').removeClass('header-nav-dropdown-expanded');
        jQuery('.toolbox-subnav-links-trigger').removeClass('toolbox-subnav-links-trigger-triggered');
        jQuery('.toolbox-subnav-links').removeClass('toolbox-subnav-links-expanded');
        jQuery('.toolbox-subnav').removeClass('toolbox-subnav-expanded');
        jQuery('.nav-overlay').fadeOut(150);
    });

    jQuery('.nav-overlay').click(function () {
        jQuery(this).fadeOut(150);
        jQuery('.header-nav-dropdown').removeClass('header-nav-dropdown-expanded');
        jQuery('.header-nav-secondary').removeClass('header-nav-secondary-expanded');
        jQuery('[rel]').removeClass('header-nav-trigger-expanded');
    });
    jQuery('.header-nav-secondary .header-nav-trigger').click(function () {
        jQuery(this).parents('.header-nav-secondary').addClass('header-nav-secondary-expanded');
    });

    jQuery('.filter-option input[type="radio"]').click(function () {
        jQuery('.filter-option').removeClass('selected');
        jQuery(this).parent().addClass('selected');
    });
    jQuery('.header-nav-toggle').click(function () {
        jQuery('.header-nav-search').removeClass('header-nav-search-toggled');
        jQuery('.header-nav-search-mobile').removeClass('header-nav-search-mobile-expanded');
        jQuery(this).toggleClass('header-nav-toggled');
        jQuery('body').toggleClass('header-nav-toggled').removeClass('header-search-toggled');
        jQuery('.header-nav-collapse').toggleClass('header-nav-collapse-expanded');
        jQuery('.header-nav-secondary').removeClass('header-nav-secondary-expanded');
        jQuery('.header-nav-dropdown').removeClass('header-nav-dropdown-expanded');
        jQuery('[rel]').removeClass('header-nav-trigger-expanded');
        jQuery('.nav-overlay').fadeOut(300);
        return false;
    });
    jQuery('.header-nav-search').click(function () {
        jQuery('.header-nav-toggle').removeClass('header-nav-toggled');
        jQuery('.header-nav-collapse').removeClass('header-nav-collapse-expanded');
        jQuery('body').toggleClass('header-search-toggled').removeClass('header-nav-toggled');
        jQuery(this).toggleClass('header-nav-search-toggled');
        jQuery('.header-nav-search-mobile').toggleClass('header-nav-search-mobile-expanded');
        return false;
    });

    jQuery('.toolbox-subnav-links-trigger').click(function () {
        jQuery(this).toggleClass('toolbox-subnav-links-trigger-triggered');
        jQuery('.toolbox-subnav-links').toggleClass('toolbox-subnav-links-expanded');
        jQuery('.toolbox-subnav').toggleClass('toolbox-subnav-expanded');
        jQuery('.nav-overlay').fadeToggle(300);
    });
    jQuery('.video-group, .video-button-trigger').click(function () {
        jQuery('.video-cover').fadeOut(300);
        if (jQuery('.is-provider-youtube')[0]) {
            jQuery('[data-video="video-cover-embed"] iframe')[0].src += '&autoplay=1';
        }
        if (jQuery('.wp-block-video')[0]) {
            jQuery('[data-video="video-cover-embed"] video').trigger('play');
        }
        return false;
    });

    var url = window.location.href;
    jQuery('.nav-tab-style li').each(function () {
        if (jQuery('a', this).attr('href') === url) {
            jQuery(this).find('.nav-link').addClass('active').attr('aria-current', 'page');
        }
    });

    jQuery('.ad-builder-header:not(.resources-view-header) ul li').each(function () {
        if (jQuery('a', this).attr('href') === url) {
            jQuery(this).find('a').addClass('active');
        }
    });

    jQuery('.toggle-button-radio').click(function () {
        jQuery(this).addClass('radio-selected');
        jQuery('.toggle-button-radio').not(this).removeClass('radio-selected');
    });

    // jQuery('.home .anchor-box-primary h2').addClass('anchor-box-links-trigger').attr({
    //   'data-bs-toggle': 'collapse',
    //   'data-bs-target': '#anchorBoxLinks'
    // });

    jQuery('.block-quote-wrapper.content-card .quote-block-read-more-link').appendTo(
        '.block-quote-wrapper.content-card .wp-block-quote'
    );

    if (jQuery(window).width() >= 992) {
        var toolboxHeight = jQuery('.toolbox-accordion--content.show').outerHeight();
        jQuery('.toolbox-accordion-container').height(toolboxHeight);

        jQuery('.toolbox-accordion--content').on('shown.bs.collapse', function () {
            var toolboxHeight = jQuery(this).outerHeight();
            jQuery('.toolbox-accordion-container').css('min-height', toolboxHeight);
        });
    }

    function initNavHighlight() {
        var currentUrl = window.location.pathname.replace(/\/$/, '');
        var navLinks = document.querySelectorAll('.ad-builder-header:not(.resources-view-header) .wp-block-list li a');
        navLinks.forEach(function (link) {
            var linkUrl = link.getAttribute('href').replace(/\/$/, '');
            if (linkUrl === currentUrl) {
                link.classList.add('active');
            } else {
                link.classList.remove('active');
            }
        });
    }

    initNavHighlight();
});

// const inpageSearchForms = document.querySelectorAll(".js-form-search-inpage");
// if (searchForms.length > 0) {
//   searchForms.forEach((form) => {
//     let searchInput = form.querySelector('input[name="s"]');
//     let clearButton = form.querySelector(".js-clear-button");

//     searchInput.addEventListener("input", () => {
//       if (searchInput.value.length > 2) {
//         clearButton.style.display = "inline-block";
//       } else {
//         clearButton.style.display = "none";
//       }
//     });

//     // Update the event listener for the enter key
//     searchInput.addEventListener("keypress", (event) => {
//       if (event.key === "Enter") {
//         form.submit(); // Submit the form
//       }
//     });

//     clearButton.addEventListener("click", (event) => {
//       event.preventDefault();
//       searchInput.value = "";
//       searchInput.focus();
//       clearButton.style.display = "none";
//     });
//   });
// }

document.addEventListener('DOMContentLoaded', () => {
    const modal = document.getElementById('anchorModalQuestion');
    if (!modal) return;

    modal.addEventListener('show.bs.modal', () => {
        const contactForm = document.getElementById('form_contact_us');
        if (!contactForm) return;

        fetchLatestUserData()
            .then((userData) => {
                const resolvedUser =
                    userData && typeof userData === 'object' && !Array.isArray(userData) ? userData : typeof window.getUserDataSnapshot === 'function' ? window.getUserDataSnapshot() : {};

                const userFullName =
                    resolvedUser?.full_name && typeof resolvedUser.full_name === 'string'
                        ? resolvedUser.full_name
                        : [resolvedUser?.given_name, resolvedUser?.family_name].filter(Boolean).join(' ').trim();
                const userEmail = resolvedUser?.user_email && typeof resolvedUser.user_email === 'string' ? resolvedUser.user_email : '';

                const fullNameInput = contactForm.querySelector('#full_name');
                if (userFullName && fullNameInput) {
                    fullNameInput.value = userFullName;
                }

                const emailInput = contactForm.querySelector('#email_address');
                if (userEmail && emailInput) {
                    emailInput.value = userEmail;
                }
            })
            .catch((error) => {
                if (window.console && console.error) {
                    console.error('Unable to refresh TPASH user', error);
                }
            });
    });

    // If the url contains a hash for an element ID and the body class contains ".page-id-1195", after the window loads and scrolls to the element, flash a light green dropshadow background around the element that does not move other elements on the page for 2 seconds to draw attention to it
    if (window.location.hash && document.body.classList.contains('page-id-1195')) {
        const targetElement = document.querySelector(window.location.hash);
        if (targetElement) {
            window.addEventListener('load', () => {
                targetElement.scrollIntoView({ behavior: 'smooth' });
                targetElement.style.transition = 'box-shadow 0.3s ease-in-out';
                targetElement.style.boxShadow = '0 0 10px 5px rgba(144, 238, 144, 0.9)';
                setTimeout(() => {
                    targetElement.style.boxShadow = 'none';
                }, 2000);
            });
        }
    }
});

// Fix ARIA role issue on Splide carousel slides
// The role="group" is invalid for <li> elements, replace with role="presentation"
// Also remove ARIA attributes that should not be on presentational elements
const fixSplideCarouselRoles = () => {
    const splideSlides = document.querySelectorAll('.splide__slide');
    splideSlides.forEach((slide) => {
        slide.removeAttribute('role');
        slide.setAttribute('role', 'presentation');
        // Remove ARIA attributes from presentational elements
        slide.removeAttribute('aria-roledescription');
        slide.removeAttribute('aria-label');
    });
};

// Run on initial page load
fixSplideCarouselRoles();

// Also run when new carousels are added dynamically
const carouselObserver = new MutationObserver(() => {
    fixSplideCarouselRoles();
});

carouselObserver.observe(document.body, { childList: true, subtree: true });

// replace "Part " anywhere in the inner HTML with "Part&nbsp;"
const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
        if (mutation.type === 'childList') {
            const addedElements = Array.from(mutation.addedNodes);
            const targetElements = addedElements.filter(
                (element) => element.nodeType === 1 && element.innerHTML.includes('Part ')
            );
            targetElements.forEach((element) => {
                element.innerHTML = element.innerHTML.replace(/Part\s/g, 'Part&nbsp;');
            });
        }
    }
});
observer.observe(document.documentElement, { childList: true, subtree: true });
const elements = document.querySelectorAll('p, h1, h2, h3, span, li');
elements.forEach((element) => {
    element.innerHTML = element.innerHTML.replace(/Part\s/g, 'Part&nbsp;');
});
